import _taggedTemplateLiteral from "/vercel/path1/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  flex: 1;\n  min-width: 0;\n  display: block;\n  position: relative;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React, { forwardRef } from 'react';
import styled from 'styled-components';
import { useForwardedRef, useCustomValidity } from '../../hooks';
import { getResponsiveProp, responsiveInputPaddingStyle, responsiveRadiusStyle, textInputStyle } from '../../styles';
var Root = styled.span(textInputStyle.root);
var InputRoot = styled.span(_templateObject());
var Input = styled.textarea(responsiveInputPaddingStyle, textInputStyle.input);
var Presentation = styled.div(responsiveRadiusStyle, textInputStyle.representation);
export var TextArea = forwardRef(function (props, forwardedRef) {
  var _props$border = props.border,
      border = _props$border === void 0 ? true : _props$border,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      _props$padding = props.padding,
      padding = _props$padding === void 0 ? [3] : _props$padding,
      paddingX = props.paddingX,
      customValidity = props.customValidity,
      paddingY = props.paddingY,
      paddingTop = props.paddingTop,
      paddingBottom = props.paddingBottom,
      paddingLeft = props.paddingLeft,
      paddingRight = props.paddingRight,
      _props$radius = props.radius,
      radius = _props$radius === void 0 ? [1] : _props$radius,
      _props$size = props.size,
      sizeProp = _props$size === void 0 ? [2] : _props$size,
      restProps = __rest(props, ["border", "disabled", "padding", "paddingX", "customValidity", "paddingY", "paddingTop", "paddingBottom", "paddingLeft", "paddingRight", "radius", "size"]);

  var paddingProps = {
    padding: padding,
    paddingX: paddingX,
    paddingY: paddingY,
    paddingTop: paddingTop,
    paddingBottom: paddingBottom,
    paddingLeft: paddingLeft,
    paddingRight: paddingRight
  };
  var ref = useForwardedRef(forwardedRef);
  useCustomValidity(ref, customValidity);
  var uiSize = getResponsiveProp(sizeProp);
  return React.createElement(Root, null, React.createElement(InputRoot, null, React.createElement(Input, Object.assign({}, restProps, paddingProps, {
    disabled: disabled,
    ref: ref,
    uiSize: uiSize
  })), React.createElement(Presentation, {
    border: border,
    radius: radius
  })));
});
TextArea.displayName = 'TextArea';